import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import * as AuthStore from "./store/modules/auth";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

axios.interceptors.response.use(
  async (response) => response,
  (error) => {
    if (error.response.status === 401) {
      AuthStore.mutations.clearUser();
    }

    return Promise.reject(error);
  }
);
